"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscoverProfile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const native_base_1 = require("native-base");
const react_1 = require("react");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const useDevice_1 = require("../../hooks/useDevice");
const MembershipInfo_1 = __importDefault(require("../../navigation/MembershipInfo"));
const NavigationLinks_1 = __importDefault(require("../../navigation/NavigationLinks"));
const discover_1 = require("../../services/discover");
const constants_1 = require("../../common/constants");
/**
 * @todo: Add characterName in API,
 * Top categories to explore
 * @returns
 */
const DiscoverProfile = () => {
    const { deviceWidth, isTabOrDesktopDevice, isWebDevice, isMobileScreen, } = (0, useDevice_1.useDevice)();
    const [stats, setStats] = (0, react_1.useState)();
    const loadCharacters = (0, react_1.useCallback)(async () => {
        await (0, discover_1.getStats)().then((statsJson) => {
            setStats(statsJson || []);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        loadCharacters();
    }, []);
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    if (!stats?.text)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)(native_base_1.ScrollView, { width: isTabOrDesktopDevice
            ? ((deviceWidth - constants_1.SIDEBAR_MAX_WIDTH - 20) * 80) / 100
            : isWebDevice
                ? "100%"
                : deviceWidth - 20, padding: isWebDevice && isMobileScreen ? 5 : undefined, alignSelf: "center", contentContainerStyle: {
            gap: isWebDevice && isMobileScreen ? 24 : undefined,
        }, children: [(0, jsx_runtime_1.jsx)(MembershipInfo_1.default, {}), (0, jsx_runtime_1.jsx)(NavigationLinks_1.default, {})] }));
};
exports.DiscoverProfile = DiscoverProfile;
